import React from 'react';
import {
  useOnboardingSectionViewIncomeLayout,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/Income/useOnboardingSectionViewIncomeLayout';

function OnboardingViewSectionIncomeLayout() {
  const Layout = useOnboardingSectionViewIncomeLayout();

  if (!Layout) {
    return null;
  }

  return <Layout />;
}

OnboardingViewSectionIncomeLayout.propTypes = {
};

OnboardingViewSectionIncomeLayout.defaultProps = {
};

export { OnboardingViewSectionIncomeLayout };
